/** @format */

export const MINUTES_IN_DAY = 60 * 24;

export const MAX_INVALID_MINUTES = MINUTES_IN_DAY * 3;

export const TICK_INTERVAL_MS = 60_000;

export const HEADER_ROUTES = {
  PROJECTS: '/grouping',
  CHIEF_REPORT: '/chief-report/summary',
  TARIFFS: '/tariffs',
  SETTINGS: '/home/settings',
  ACCOUNT: '/home/settings/profile',
  AI_REPORTS: '/home/ai-reports',
};
